import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as emailComplianceApi from '../Api/emailComplianceApi';

const COMPLIANCE_KEY = 'emailCompliance';

export const useEmailCompliance = (companyId, options = {}) => {
	const { refetchInterval } = options;
	return useQuery({
		queryKey: [COMPLIANCE_KEY, companyId],
		queryFn: async () => {
			const res = await emailComplianceApi.getEmailCompliance(companyId);
			return res.data;
		},
		enabled: !!companyId,
		refetchInterval,
	});
};

export const useSubmitEmailVetting = (companyId) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data) => emailComplianceApi.submitEmailVetting(companyId, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [COMPLIANCE_KEY, companyId] });
		},
	});
};

export const usePendingEmailVetting = (enabled = true) =>
	useQuery({
		queryKey: [COMPLIANCE_KEY, 'pending'],
		queryFn: async () => {
			const res = await emailComplianceApi.listPendingEmailVetting();
			return res.data?.companies || [];
		},
		enabled,
	});

export const useEmailComplianceListByTab = (tab, enabled = true) =>
	useQuery({
		queryKey: [COMPLIANCE_KEY, 'adminList', tab],
		queryFn: async () => {
			const res = await emailComplianceApi.listEmailComplianceByTab(tab);
			return res.data?.companies || [];
		},
		enabled: enabled && !!tab,
	});

export const useEmailComplianceAdminStats = (enabled = true) =>
	useQuery({
		queryKey: [COMPLIANCE_KEY, 'adminStats'],
		queryFn: async () => {
			const res = await emailComplianceApi.getEmailComplianceAdminStats();
			return res.data?.stats || {};
		},
		enabled,
		refetchInterval: 60 * 1000,
	});

export const useReviewEmailVetting = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ companyId, ...data }) =>
			emailComplianceApi.reviewEmailVetting(companyId, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [COMPLIANCE_KEY] });
			queryClient.invalidateQueries({ queryKey: [COMPLIANCE_KEY, 'adminStats'] });
			queryClient.invalidateQueries({ queryKey: [COMPLIANCE_KEY, 'adminList'] });
			queryClient.invalidateQueries({ queryKey: ['sendGridSubuser'] });
		},
	});
};

export const useProvisionSubuserForCompany = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (companyId) =>
			emailComplianceApi.provisionSubuserForCompany(companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [COMPLIANCE_KEY, 'adminList'] });
			queryClient.invalidateQueries({ queryKey: ['sendGridSubuser'] });
		},
	});
};
